import { render } from "./TopProperty.vue?vue&type=template&id=35a1fafe&ts=true"
import script from "./TopProperty.vue?vue&type=script&lang=ts"
export * from "./TopProperty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__